import type {Level} from 'shells/status-badge/status-badge';

import type {
    GetInboxStatus_inboxStatus as InboxStatus,
    GetInboxStatus_inboxStatus_phoneStatus as PhoneStatus,
    GetInboxStatus_inboxStatus_firstMessageStatus as FirstMessageStatus,
    GetInboxStatus_inboxStatus_firstCampaignStatus as FirstCampaignStatus,
} from 'nutshell-graphql-types';

export const getIsEnrollmentFormNotStarted = (inboxStatus?: InboxStatus | null): boolean => {
    return Boolean(inboxStatus && inboxStatus.enrollmentFormStatus.status === 'NOT_STARTED');
};

export const getIsEnrolled = (inboxStatus?: InboxStatus | null): boolean => {
    return Boolean(
        inboxStatus && inboxStatus.enrollmentFormStatus.status === 'SUBMISSION_ACCEPTED'
    );
};

export const getIsUnderReview = (inboxStatus?: InboxStatus | null): boolean => {
    return Boolean(
        inboxStatus &&
            (inboxStatus.enrollmentFormStatus.status === 'SUBMISSION_VALIDATING' ||
                inboxStatus.enrollmentFormStatus.status === 'UNDER_REVIEW')
    );
};

export const getPhoneNumber = (inboxStatus?: InboxStatus | null): string | null | undefined => {
    return (
        inboxStatus &&
        inboxStatus.phoneStatus.nutshellChannel &&
        inboxStatus.phoneStatus.nutshellChannel.phone &&
        inboxStatus.phoneStatus.nutshellChannel.phone.numberFormatted
    );
};

export const getRemainingCredits = (inboxStatus?: InboxStatus | null): number => {
    return inboxStatus ? inboxStatus.planStatus.remainingCredits : 0;
};

export const getHasSentMessage = (inboxStatus?: InboxStatus | null): boolean => {
    return Boolean(inboxStatus && inboxStatus.firstMessageStatus.hasBeenSent);
};

export const getHasSentCampaign = (inboxStatus?: InboxStatus | null): boolean => {
    return Boolean(inboxStatus && inboxStatus.firstCampaignStatus.hasBeenSent);
};

export const getIsPhoneStatusValid = (inboxStatus?: InboxStatus | null): boolean => {
    return Boolean(inboxStatus && inboxStatus.phoneStatus.status === 'VALID');
};

export const getPhoneStatusBadgeFromInboxStatus = (
    phoneStatus: PhoneStatus
): {
    level: Level;
    text: string;
} => {
    switch (phoneStatus.status) {
        case 'VALID':
            return {level: 'success', text: 'Valid'};
        case 'INVALID':
            return {level: 'alert', text: 'Invalid'};
        case 'NOT_SELECTED':
        default:
            return {level: 'info--grey', text: 'Not selected'};
    }
};

export const getFirstMessageStatusBadgeFromInboxStatus = (
    firstMessageStatus: FirstMessageStatus | FirstCampaignStatus,
    canSendMessages: boolean
): {
    level: Level;
    text: string;
} => {
    if (!canSendMessages) {
        return {level: 'info--grey', text: 'Not yet available'};
    } else {
        return firstMessageStatus.hasBeenSent
            ? {level: 'success', text: 'Sent'}
            : {level: 'info--grey', text: 'Not sent'};
    }
};
